import Joi from '@hapi/joi'

export const advancedRequestSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity Required`,
        "any.required": `Operation Entity Required`
    }),
    collectionPointID:Joi.number().label("CollectionPoint").messages({
        "any.invalid": `CollectionPoint Required`,
        "any.required": `CollectionPoint Required`
    }),
    fromDate:Joi.string().invalid("").required().label("Search Date").messages({
        "any.invalid": `From Date Required`,
        "any.required": `From Date Entity Required`
    }),
    toDate:Joi.string().invalid("").required().label("Search Date").messages({
        "any.invalid": `To Date Required`,
        "any.required": `To Date Required`
    }),
    statusID:Joi.number().label("Status").messages({
        "any.invalid": `Status Required`,
        "any.required": `Status Required`
    }),
    approvedAmount:Joi.string().max(100).allow("", null).label("Address2").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    reason: Joi.string().alphanum().max(50).allow("", null).label("reason").messages({
        "string.pattern.base": `Please enter valid City`,
        "string.max": `Please enter {#limit} characters.`
    }),
}
